<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-card class="pa-2 pt-0" flat>
        <v-card-title>افزودن ویدئو</v-card-title>
        <v-card-subtitle>
          برای استفاده از ویدئو با لینک خارجی، لطفا فیلدهای زیر را پر نمایید
        </v-card-subtitle>

        <v-row justify="center" no-gutters>
          <v-col
            v-for="(item, i) in manualVideo"
            :key="i"
            class="pa-2 d-flex align-start"
            cols="12"
            lg="10"
          >
            <div
              clas="rowinfo row"
              style="
                width: 100% !important;
                flex-wrap: nowrap !important;
                display: flex !important;
                justify-content: center;
                align-items: baseline;
              "
            >
              <v-text-field
                v-model="item.file_link"
                :label="
                  item.type === 'iframe' ? 'کد آی فرم ویدئو' : 'لینک ویدئو'
                "
                :rules="[
                  addVideoRule.required,
                  item.type === 'iframe' ? addVideoRule.url : addVideoRule.link,
                ]"
                clear-icon="mdi-close-circle-outline"
                clearable
                dense
                outlined
                class="contentinfo"
              >
                <template v-slot:append>
                  <v-btn
                    class="mt-n1 ml-n1"
                    icon
                    @click="
                      () => {
                        item.type = item.type === 'link' ? 'iframe' : 'link';
                        item.file_link = '';
                      }
                    "
                  >
                    <v-icon
                      >mdi-{{
                        item.type === "iframe" ? "video-vintage" : "link"
                      }}</v-icon
                    >
                  </v-btn>
                </template>
              </v-text-field>
              <help-info
                v-if="i === 0"
                :element-name="`${serviceName}-${componentName}-filelink`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                :label="
                  item.type === 'iframe' ? 'کد آی فرم ویدئو' : 'لینک ویدئو'
                "
              />
              <v-btn
                v-if="manualVideo.length > 1"
                class="rounded-lg mr-1"
                color="error"
                fab
                outlined
                x-small
                @click="manualVideo.splice(i, 1)"
              >
                <v-icon>mdi-minus</v-icon>
              </v-btn>
              <help-info
                v-if="manualVideo.length > 1 && i === 0"
                :element-name="`${serviceName}-${componentName}-manualVideo`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                label="حذف"
              />
              <v-btn
                class="rounded-lg mr-1"
                color="success"
                fab
                outlined
                x-small
                @click="pushVideo"
              >
                <v-icon>mdi-plus</v-icon>
              </v-btn>
              <help-info
                v-if="i === 0"
                :element-name="`${serviceName}-${componentName}-pushVideo`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                label="ویدئو"
              />
            </div>
          </v-col>

          <!--      <v-col class="pa-2" cols="12" lg="5" md="6">-->
          <!--        <suggest-text v-model="manualVideo.title" class="my-2" label="عنوان" rows="1"/>-->
          <!--      </v-col>-->

          <!--      <v-col class="pa-2" cols="12" lg="5" md="6">-->
          <!--        <v-text-field v-model="manualVideo.link" :rules="[addVideoRule.link]" class="my-2"-->
          <!--                      clear-icon="mdi-close-circle-outline" clearable dense label="لینک انتقال" outlined/>-->
          <!--      </v-col>-->

          <!--      <v-col class="pa-2" cols="12" lg="5" md="6">-->
          <!--        <suggest-text v-model="manualVideo.description" class="my-2" label="توضیحات" rows="1"/>-->
          <!--      </v-col>-->

          <v-col class="text-left px-2 pb-2" cols="12" lg="10">
            <div class="rowinfo">
              <v-btn
                :disabled="!canAddVideo"
                :loading="loading"
                class="btn-sub ms-auto px-8"
                clear-icon="mdi-close-circle-outline"
                clearable
                color="green lighten-3"
                @click="addVideoManual"
              >
                افزودن
              </v-btn>
              <help-info
                :disabled="!canAddVideo"
                :element-name="`${serviceName}-${componentName}-add-video`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                label="افزودن"
              />
            </div>
          </v-col>
        </v-row>
      </v-card>
    </template>
  </help-info-wrapper>
</template>

<script>
import SuggestText from "../../SuggestBox/suggestInput.vue";

export default {
  name: "videoByLink",

  components: { SuggestText },

  props: {
    images: Array,
  },

  data() {
    return {
      helpData: [],
      serviceName: "Qrland",
      componentName: "videoByLink",

      addVideoRule: {
        required: (value) => !!value || "فیلد الزامی میباشد.",
        url: (value) => {
          const pattern = new RegExp(/<iframe.*src="(.*?)".*>/, "gms");
          return pattern.test(value) || "لینک اشتباه";
        },
        link: (value) =>
          this.isDomain(value) ||
          "دامنه سایت باید بصورت https://terminalads.com یا terminalads.com وارد شود. ",
      },
      manualVideo: [
        {
          title: "",
          file_link: "",
          description: "",
          link: "",
          type: "link",
        },
      ],
      fromIframe: false,
      loading: false,
    };
  },

  computed: {
    canAddVideo() {
      const _this = this;

      function hasLink(el, index, arr) {
        return (
          typeof _this.addVideoRule[el.type === "iframe" ? "url" : "link"](
            el.file_link
          ) === "boolean"
        );
      }

      return this.manualVideo.every(hasLink);
    },
    computedImages: {
      get() {
        return this.images;
      },
      set(val) {
        this.$emit("update:images", val);
      },
    },
  },

  methods: {
    addVideoManual() {
      let mv = this.manualVideo;
      const _this = this;

      function handleType() {
        if (!mv.length) {
          _this.manualVideo = [
            {
              title: "",
              url: "",
              file_link: "",
              description: "",
              link: "",
              type: "link",
            },
          ];

          _this.$emit("fetch");
          _this.$emit("close");
        } else {
          if (mv[0]?.type === "link") {
            _this.computedImages.push(mv[0]);
            !!mv?.length && mv.shift();
            handleType();
          } else {
            _this.loading = true;

            let reg = new RegExp(/<iframe.*src="(.*?)".*>/, "gms");
            let v = {
              ...mv[0],
              file_link: reg.exec(mv[0].file_link)?.[1] ?? mv[0].file_link,
            };

            _this
              .getAparatVideoInfo(v.file_link)
              .then(({ data }) => {
                v.title = data.title;
                v.description = data.description;
                saveAparat(v);
              })
              .catch(({ response }) => {
                console.log("failed to get aparat info url: ", response);
                saveAparat(v);
              });
          }
        }
      }

      function saveAparat(obj) {
        _this.$api
          .post("/user/aparat/default", obj)
          .then(({ data }) => {
            try {
              !!mv?.length && mv.shift();
              handleType();
            } catch (e) {
              console.log(e);
            }
          })
          .catch(({ response }) => {
            console.log("error in upload video defaults: ", response);
            _this.$toast.warning("افزودن ویدئو به گالری با خطا روبرو شد.");
          })
          .finally(() => (_this.loading = false));
      }

      handleType();
    },
    pushVideo() {
      this.manualVideo.push({
        title: "",
        file_link: "",
        description: "",
        link: "",
        type: "link",
      });
    },
    isDomain(str) {
      var regex = new RegExp(
        "^(http[s]?:\\/\\/(www\\.)?|ftp:\\/\\/(www\\.)?|www\\.){1}([0-9A-Za-z-\\.@:%_\+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?"
      );
      var without_regex = new RegExp(
        "^([0-9A-Za-z-\\.@:%_\+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?"
      );

      return regex.test(str) || without_regex.test(str);
    },
    getAparatVideoInfo(url) {
      return new Promise((resolve, reject) => {
        this.$api
          .get("/user/aparat/info", {
            params: {
              url,
            },
          })
          .then(({ data }) => {
            resolve(data);
          })
          .catch(({ response }) => {
            reject(response);
          });
      });
    },
  },
};
</script>

<style scoped></style>
